import { buildHref } from "@softmax/web-addresses";
import { redirect } from "@tanstack/react-router";
import { getActualViewer } from "@/data/viewer";

export async function requireCreatorViewer({
  signal,
  returnTo = buildHref({ name: "coworlds" }),
}: {
  signal?: AbortSignal | undefined;
  returnTo?: string;
}) {
  const viewer = await getActualViewer({ signal });

  if (viewer?.subject_type !== "user") {
    throw redirect({
      href: buildHref({
        name: "signIn",
        search: new URLSearchParams({ redirect_url: returnTo }),
      }),
      statusCode: 307,
      headers: { "Cache-Control": "private, no-store" },
    });
  }

  return viewer;
}
